// @flow
export const COUNTRY_CODE_NLD = 'NLD'
export const COUNTRY_CODE_BEL = 'BEL'
export const COUNTRY_CODE_DEU = 'DEU'
export type CountryCode = 'NLD' | 'BEL' | 'DEU'



// WEBPACK FOOTER //
// ./src/types/country-code.js